import { millionComma } from "../../utils";

export const formatStatusBadge = (data) => {
  let statusText = formatStatus(data);
  let statusColor =
    statusText == "Approved"
      ? "text-bg-success"
      : statusText == "Rejected"
        ? "text-bg-danger" : statusText == "Partial Done" ? "text-bg-warning"
          : "text-bg-warning";

  return (
    <>
      <span
        className={`badge ${statusColor}`}
        style={{ fontSize: "11px" }}
        role="button"
      >
        {statusText}
      </span>
    </>
  );
};

export const formatStatus = (data, key = "is_active") => {
  let status = ["Pending", "Approved", "Rejected", "Partial Done"];

  return status[Number(data[key]) - 1];
};

export const formatAmount = (data) => {
  let amount = 0;

  data?.item_dtl?.forEach((item) => {
    amount += Number(item?.amount);
  });

  amount = millionComma(amount);

  return amount;
};

export const formatAmountChallan = (v) => {
  if (!v?.item_dtl || v.item_dtl.length === 0) {
    return 0;
  }

  const grossTotal = v.item_dtl.reduce((total, item) => {
    const requestedQty = parseFloat(item?.requested_qty || 0);
    const rate = parseFloat(item?.rate || 0);

    return total + (rate * requestedQty);
  }, 0);

  return millionComma(grossTotal.toFixed(2));
}


export const formatAmountChallanRtn = (v) => {
  if (!v?.challan_dtl || v.challan_dtl.length === 0) {
    return 0;
  }

  const grossTotal = v.challan_dtl.reduce((total, item) => {
    const qty = parseFloat(item?.qty || 0);
    const rate = parseFloat(item?.rate || 0);

    return total + (rate * qty);
  }, 0);

  return millionComma(grossTotal.toFixed(2));
}



